export class TableContextFinding {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "kind",
            "baseName": "kind",
            "type": "TableContextFindingKind",
            "format": ""
        },
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        },
        {
            "name": "text",
            "baseName": "text",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextFinding.attributeTypeMap;
    }
    constructor() {
    }
}
